import { createSlice } from '@reduxjs/toolkit';
import { getFirstDayOfYear } from '../utils/common';
import moment from 'moment/moment';

const initialState = {
  processStatus: { tab: 0, startDateRange: '', procInstStatus: '', procCat: '' }, //process
  missiveStatus: { onlyDone: false, category: '全部', tab: 0 }, // missive
  commandStatus: '待处理', //command
  wageTime: { startDate: getFirstDayOfYear(new Date()), endDate: new Date().getTime() }, //wage
  feedbackHandler: { tab: 0 }, //feedbackHandler
  saleMarketStatus: { theDate: new Date().getTime(), type: { label: '市场', value: { searchType: '市场' } } }, //saleMarketReport
  saleMonthStatus: {
    dateStart: moment().startOf('year').toDate().getTime(),
    dateEnd: moment().subtract(1, 'month').toDate().getTime(),
    type: { label: '市场', value: { searchType: '市场' } },
    theMode: { label: '多月分月' },
  }, //saleMarketReport
};

export const stateSlice = createSlice({
  name: 'state',
  initialState,
  reducers: {
    setProcessStatus: (state, action) => {
      state.processStatus = action.payload;
    },
    setOnlyDone: (state, action) => {
      state.missiveStatus = action.payload;
    },
    setStatus: (state, action) => {
      state.commandStatus = action.payload;
    },
    setWageTime: (state, action) => {
      state.wageTime = action.payload;
    },
    setFeedbackHandler: (state, action) => {
      state.feedbackHandler = action.payload;
    },
    setSaleMarketStatus: (state, action) => {
      state.saleMarketStatus = action.payload;
    },
    setSaleMonthStatus: (state, action) => {
      state.saleMonthStatus = action.payload;
    },
  },
});

export const { setProcessStatus, setOnlyDone, setStatus, setWageTime, setFeedbackHandler, setSaleMarketStatus, setSaleMonthStatus } =
  stateSlice.actions;
export const processStatus = (state) => state.state.processStatus;
export const missiveStatus = (state) => state.state.missiveStatus;
export const commandStatus = (state) => state.state.commandStatus;
export const wageTime = (state) => state.state.wageTime;
export const feedbackHandler = (state) => state.state.feedbackHandler;
export const saleMarketStatus = (state) => state.state.saleMarketStatus;
export const saleMonthStatus = (state) => state.state.saleMonthStatus;
export default stateSlice.reducer;
